<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>燃烧小宇宙，重燃热血信仰！卡牌手游《破阵勇士》华丽降临，集结星矢、紫龙、冰河等经典角色，打造专属圣斗士军团！还原天马流星拳、钻石星尘拳等超燃必杀，策略组合触发羁绊奥义！全3D高清建模重现黄金十二宫、海界冥域等史诗战场，沉浸式体验圣战史诗！实时PVP挑战全球斗士，争夺银河之巅荣耀！开启你的守护雅典娜之战！</p>
    <!-- <pre> -->
    <h2 class="title" style="margin-bottom: 0px">游戏特色</h2>
    <div class="content">
      <div class="content-item">
        <h4>【3D还原 忠于原著】</h4>
        环绕音效重现热血战役，逼真的场景，呐喊式的战斗，与儿时记忆重叠的主线剧情，是幻想？不！是真实！
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【玩转策略 热血激情】</h4>
        顶级音效，奏响热血战斗的乐章！拳拳到肉的热血对决，圣衣带来的属性质变，用智力达成你的目标！
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【星座加成 合成革新】</h4>
        陪伴角色成长，解锁更深层的星座故事，多种策略玩法多维养成，技能装备全新合成思路，创新才耐玩！
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【数值平衡 福利白给】</h4>
        新服狂欢豪礼送足一个月！人均欧皇轻松集卡轻松养成，高概率高收益，每个玩家都能爆发小宇宙！
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
